import React from 'react';
import PropTypes from 'prop-types';
import Markdown from 'react-markdown';

import './judges.scss';
import Keynote from './Keynote';
import Judge from './Judge';

const Judges = ({ data }) => (
  <div className="abs-asset-holder judges-container">
    <div id="Judges" />
    <div className="container">
      <Keynote title={data.keynote.title} image={data.keynote.image} watch={data.keynote.watch}>
        <Markdown>{data.keynote.body}</Markdown>
      </Keynote>
      <h1 className="judges__header">
        {data.judges_title}
      </h1>
      <div className="judges">
        {
          data.judge_list.map(({ judge: { name, description, image } }) => (
            <Judge
              name={name}
              description={description}
              image={image}
            />
          ))
        }
      </div>
    </div>
  </div>
);

/* eslint-disable function-paren-newline */
Judges.propTypes = {
  data: PropTypes.shape({
    keynote: PropTypes.shape({
      title: PropTypes.string.isRequired,
      body: PropTypes.string.isRequired,
    }).isRequired,
    judge_list: PropTypes.arrayOf(
      PropTypes.shape({
        judge: PropTypes.shape({
          name: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired,
          image: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    ).isRequired,
  }).isRequired,
};

export default Judges;



// WEBPACK FOOTER //
// ./src/components/Judges/index.jsx